export enum APIMEnvironment {
    DEV,
    TEST,
    PROD,
}